import { pilot } from '../../services/serviceInstances';

export const getFolderTree = () => pilot.get('/path/');
